import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PrivateRoutes } from 'src/app/config/config.routes';
import { mixpanelEvent } from 'src/app/config/mixpanel-events';
import { MixpanelService } from 'src/app/services/analytics/mixpanel.service';
import {} from 'src/app/services/api-lab4u/tutoria/tutoria.service';
import { UserSessionService } from 'src/app/services/user/user.service';
import { ChatMessage } from 'src/app/shared/chatbot/chatbot.component';
import {
  CreateChatCompletionForTutorIAV2_Req,
  CreateChatCompletionForTutorIAV3_Req,
  GetChatSessionForTutorIA_Req,
  GetAllChatSessionsForTutorIA_Req,
  TutoriaService,
} from '../services/api-lab4u/tutoria/tutoria.service';
import { v4 as guidV4 } from 'uuid';
import { DealManagerService } from '../services/api-lab4u/deal-manager/deal-manager.service';
import { ClientSystemService } from '../services/api-lab4u/client_system.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { NgClass } from '@angular/common';
import { ChatbotComponent } from '../shared/chatbot/chatbot.component';
import { AuthService } from '../services/auth/auth.service';

declare function init_tutoria(): void;

interface StudyOption {
  name: string;
  labelVerb: string;
  keyword: string;
  modifierId: string;
  modifierTypeId: string;
  iconPath: string;
}

interface StudySubOption {
  name: string;
  keyword: string;
  modifierTypeId: string;
  studyOptionKeyword: string;
  subjectModifierId: string;
}

interface TutoriaSession {
  userId: string;
  userEmail: string;
  userToken: string;
  isLocalSession: boolean;
}

/** Possible states for the TutorIA state machine */
enum ViewState {
  SELECTING_STUDY_OPTION = 'SELECTING_STUDY_OPTION',
  SELECTING_TFL = 'SELECTING_TFL',
  SELECTING_TEAM = 'SELECTING_TEAM',
  CHATTING = 'CHATTING',
}

/** Possible values for teamwork */
enum TeamworkType {
  INDIVIDUAL_WORK = 'INDIVIDUAL_WORK',
  TEAM_WORK = 'TEAM_WORK',
}

/** Default study options */
const SCHOOL_STUDY_OPTIONS: StudyOption[] = [
  {
    name: 'Biología',
    labelVerb: 'Estudiar',
    keyword: 'BIOLOGY',
    modifierId: '',
    modifierTypeId: '',
    iconPath: '../../assets/images/tutoria/biology-icon.svg',
  },
  {
    name: 'Física',
    labelVerb: 'Estudiar',
    keyword: 'PHYSICS',
    modifierId: '',
    modifierTypeId: '',
    iconPath: '../../assets/images/tutoria/physics-icon.svg',
  },
  {
    name: 'Química',
    labelVerb: 'Estudiar',
    keyword: 'CHEMISTRY',
    modifierId: '',
    modifierTypeId: '',
    iconPath: '../../assets/images/tutoria/chemistry-icon.svg',
  },
  //TODO Enable when indicated by Product.
  // {
  //   name: 'Matemáticas',
  //   labelVerb: 'Estudiar',
  //   keyword: 'MATH',
  //   iconPath: '../../assets/images/tutoria/math-icon.svg',
  // },
  {
    name: 'PAES de Ciencias',
    labelVerb: 'Estudiar',
    keyword: 'SCIENCE_PAES',
    modifierId: '',
    modifierTypeId: '',
    iconPath: '../../assets/images/tutoria/science-paes-icon.svg',
  },
];

/** INACAP study Options */
const INACAP_STUDY_OPTIONS: StudyOption[] = [
  {
    name: 'Física Mecánica',
    labelVerb: 'Estudiar',
    keyword: 'MECHANICAL_PHYSICS_I_INACAP',
    modifierId: '',
    modifierTypeId: '',
    iconPath: '../../assets/images/tutoria/mechanical-physics-i-icon.svg',
  },
  {
    name: 'Química General',
    labelVerb: 'Estudiar',
    keyword: 'GENERAL_CHEMISTRY_INACAP',
    modifierId: '',
    modifierTypeId: '',
    iconPath: '../../assets/images/tutoria/general-chemistry-icon.svg',
  },
  {
    name: 'ABPro de Física Mecánica',
    labelVerb: 'Diseñar',
    keyword: 'PROJECTS_INACAP',
    modifierId: '',
    modifierTypeId: '',
    iconPath: '../../assets/images/tutoria/abpro-mechanical-physics.svg',
  },
  {
    name: 'ABPro de Funciones y Progresiones',
    labelVerb: 'Diseñar',
    keyword: 'ABPRO_MATH_INACAP',
    modifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_PROGRE_INACAP',
    modifierTypeId: 'INACAP_SUBJECT_MATE',
    iconPath: '../../assets/images/tutoria/abpro-functions-progressions.svg',
  },
  {
    name: 'ABPro de Funciones y Geometría',
    labelVerb: 'Diseñar',
    keyword: 'ABPRO_MATH_INACAP',
    modifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_GEOME_INACAP',
    modifierTypeId: 'INACAP_SUBJECT_MATE',
    iconPath: '../../assets/images/tutoria/abpro-functions-geometry.svg',
  },
  {
    name: 'ABPro de Funciones y Matrices',
    labelVerb: 'Diseñar',
    keyword: 'ABPRO_MATH_INACAP',
    modifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_MATTRI_INACAP',
    modifierTypeId: 'INACAP_SUBJECT_MATE',
    iconPath: '../../assets/images/tutoria/abpro-functions-matrices.svg',
  },
];

@Component({
  selector: 'app-tutoria',
  templateUrl: './tutoria.component.html',
  styleUrls: ['./tutoria.component.css'],
  // This is for the Chat History menu, so it does the animation on opening/closing
  animations: [
    trigger('slideInOut', [
      state('void', style({ transform: 'translateX(-100%)' })),
      state('*', style({ transform: 'translateX(0)' })),
      transition('void <=> *', animate('150ms ease-in-out')),
    ]),
  ],
  imports: [NgClass, ChatbotComponent],
})
export class TutoriaComponent implements OnInit {
  desktopWidthBreakpoint = 1200;

  //* USER DATA
  // User Id using the app
  userId = '';
  // User email
  userEmail = '';
  // Session User Token, the one implemented for security reasons
  userToken = '';
  // User's Deal ID
  dealId = '';

  //* CHAT PROPERTIES
  // Chat Session Id of the current conversation
  chatSessionId: string | null = null;
  // Current response of the AI agent
  assistantResponse = '';

  //* FLAGS
  // Show or hide the biggest wrapper of the component
  displayView = false;
  // Show or hide the arrow in the initial view
  enableInitialArrow = false;
  // Disable the textarea and submit button of the chatbot component
  disableUserInput = false;
  // Flag to show or hide the Chat History menu
  showHistoryChatMenu = false;
  // Flag to show or hide the Chat History sidebar
  showHistoryChatSidebar = true;
  // Flag to show or hide AI reminder
  showAiReminder = true;

  //* STATE MACHINE
  // This is needed so the component has access to the ViewState enum
  ViewState = ViewState;
  // Current state of the machine. DO NOT change this directly, use the function updateState()
  currentState: ViewState = ViewState.SELECTING_STUDY_OPTION;

  //* CONTENT OPTIONS
  // All values for Study Options/Content Type. It's set after checking the user's deal.
  studyOptions: StudyOption[] = [];
  // All values for Study Sub-Options/Content Sub-Type
  studySubOptions: StudySubOption[] = [
    {
      name: 'Automatización y Robótica',
      keyword: 'INACAP_TFL_FISI_MECA_AUTO_Y_ROBO',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Climatización y Refrigeración',
      keyword: 'INACAP_TFL_FISI_MECA_CLIMA_Y_REFRI',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Energías Renovables',
      keyword: 'INACAP_TFL_FISI_MECA_ENER_RENO',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Mantenimiento Industrial',
      keyword: 'INACAP_TFL_FISI_MECA_CMANTE_INDUS',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Mantenimiento de Plantas Mineras',
      keyword: 'INACAP_TFL_FISI_MECA_MANTE_PLANTAS_MINE',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Maquinaria Pesada',
      keyword: 'INACAP_TFL_FISI_MECA_MAQUI_PESA',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Mecatrónica',
      keyword: 'INACAP_TFL_FISI_MECA_MECA',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Medioambiente y Sustentabilidad',
      keyword: 'INACAP_TFL_FISI_MECA_MEDIO_Y_SUSTEN',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Minería',
      keyword: 'INACAP_TFL_FISI_MECA_MINE',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Vehículos Automotrices',
      keyword: 'INACAP_TFL_FISI_MECA_VEHI_AUTO',
      modifierTypeId: 'INACAP_TFL_FISI_MECA',
      studyOptionKeyword: 'PROJECTS_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Administración de Empresas',
      keyword: 'INACAP_TFL_MATE_ADMIN_EMPRE',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_PROGRE_INACAP',
    },
    {
      name: 'Administración Pública',
      keyword: 'INACAP_TFL_MATE_ADMIN_PUBLI',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_PROGRE_INACAP',
    },
    {
      name: 'Analista Programador',
      keyword: 'INACAP_TFL_MATE_ANA_PROGRA',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_MATTRI_INACAP',
    },
    {
      name: 'Comercio Exterior',
      keyword: 'INACAP_TFL_MATE_COMER_EXTE',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_PROGRE_INACAP',
    },
    {
      name: 'Contabilidad General',
      keyword: 'INACAP_TFL_MATE_CONTA_GENE',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_PROGRE_INACAP',
    },
    {
      name: 'Contador Público',
      keyword: 'INACAP_TFL_MATE_CONTA_PUBLI',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_PROGRE_INACAP',
    },
    {
      name: 'Ingeniería en Administración de Empresas',
      keyword: 'INACAP_TFL_MATE_ING_ADMIN_EMPRE',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_PROGRE_INACAP',
    },
    {
      name: 'Ingeniería en Ciberseguridad',
      keyword: 'INACAP_TFL_MATE_ING_CIBERSEG',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_MATTRI_INACAP',
    },
    {
      name: 'Ingeniería en Comercio Exterior',
      keyword: 'INACAP_TFL_MATE_ING_COMER_EXTE',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_PROGRE_INACAP',
    },
    {
      name: 'Ingeniería en Informática',
      keyword: 'INACAP_TFL_MATE_ING_INFOR',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_MATTRI_INACAP',
    },
    {
      name: 'Técnico en Administración Pública',
      keyword: 'INACAP_TFL_MATE_TEC_ADMIN_PUBLI',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: '',
    },
    {
      name: 'Técnico en Prevención de Riesgos y Gestión de Emergencias',
      keyword: 'INACAP_TFL_MATE_TEC_PREVEN_RIESGOS',
      modifierTypeId: 'INACAP_TFL_MATE',
      studyOptionKeyword: 'ABPRO_MATH_INACAP',
      subjectModifierId: 'INACAP_SUBJECT_MATE_FUNCIO_Y_GEOME_INACAP',
    },
  ];
  // Study Option selected for the User at this time
  selectedStudyOption: StudyOption = {
    name: '',
    labelVerb: '',
    keyword: '',
    modifierId: '',
    modifierTypeId: '',
    iconPath: '',
  };
  // Selectable Study Sub-Options for the User by Study Option selection.
  selectableStudySubOptions: StudySubOption[] = [];
  // Study Sub-Option selected for User at this time
  selectedStudySubOption: StudySubOption = {
    name: '',
    keyword: '',
    modifierTypeId: '',
    studyOptionKeyword: '',
    subjectModifierId: '',
  };

  //* TEAMWORK OPTIONS
  TeamworkType = TeamworkType;
  isSectionCollapsed: Record<string, boolean> = {
    TFL: false,
    'TEAMWORK-TYPE': false,
    CLASSROOM: false,
    CLASSMATES: true,
  };
  selectedTeamworkType: TeamworkType | undefined;
  userClassrooms: { id: string; name: string; campus_name: string }[] = [];
  selectedClassroom:
    { id: string; name: string; campus_name: string } | undefined;
  loadingClassroomProfile = false;
  fetchedClassroomStudents: Record<
    string,
    { id: string; firstName: string; lastName: string }[]
  > = {};
  userClassmates: { id: string; firstName: string; lastName: string }[] = [];
  selectedClassmates: { id: string; firstName: string; lastName: string }[] =
    [];
  selectedClassmateIds = new Set<string>();
  isStudent = false;

  //* CHAT HISTORY PROPERTIES
  // Old Chat Sessions for the Chat History menu
  chatHistoryElements:
    | {
        id: string;
        title: string;
      }[]
    | null = null;
  // When loading an old Chat Session the messages are stored here before loading the chatbot
  messagesToLoad: ChatMessage[] | null = null;

  //$ ---- BUILT-IN ----
  constructor(
    private cdr: ChangeDetectorRef,
    public mixpanelService: MixpanelService,
    private route: ActivatedRoute,
    public router: Router,
    public tutoriaService: TutoriaService,
    public UserSessionService: UserSessionService,
    private authService: AuthService,
    public dealManagerService: DealManagerService,
    public clientSystemService: ClientSystemService,
  ) {}

  ngOnInit() {
    if (typeof init_tutoria === 'function') init_tutoria();

    //$ GET VALUES FROM URL
    this.route.queryParams.subscribe((params) => {
      const session = this.resolveTutoriaSession(params);
      if (!session) {
        this.redirectToSignIn();
        return;
      }

      this.setTutoriaSession(session);

      if (session.isLocalSession) {
        this.authService.verifyToken(this.userId, this.userToken).subscribe({
          next: (isTokenValid) => {
            if (!isTokenValid) {
              this.authService.logout();
              return;
            }
            this.initializeTutoriaApp();
          },
          error: () => this.authService.logout(),
        });
        return;
      }

      this.initializeTutoriaApp();
    });

    this.updateChatHistoryMenuBasedOnWidth();
  }

  private resolveTutoriaSession(
    params: Record<string, string>,
  ): TutoriaSession | null {
    const {
      user_id: userId,
      user_email: userEmail,
      user_token: userToken,
    } = params;

    if (userId && userEmail && userToken) {
      return {
        userId,
        userEmail,
        userToken,
        isLocalSession: false,
      };
    }

    const storedUser = this.getStoredUser();
    const storedUserId = localStorage.getItem('userId');
    const storedUserToken = localStorage.getItem('token');
    const storedUserEmail = storedUser?.email;

    if (!(storedUserId && storedUserEmail && storedUserToken)) return null;

    return {
      userId: storedUserId,
      userEmail: storedUserEmail,
      userToken: storedUserToken,
      isLocalSession: true,
    };
  }

  private getStoredUser() {
    const rawUser = localStorage.getItem('user');
    if (!rawUser) return null;

    try {
      return JSON.parse(rawUser);
    } catch (_error) {
      return null;
    }
  }

  private setTutoriaSession(session: TutoriaSession): void {
    this.userId = session.userId;
    this.userEmail = session.userEmail;
    this.userToken = session.userToken;
    this.enableInitialArrow = session.isLocalSession;
  }

  private redirectToSignIn(): void {
    this.router.navigate(['/sign-in'], {
      queryParams: { redirectUrl: PrivateRoutes.TUTORIA },
    });
  }

  private initializeTutoriaApp(): void {
    //$ INITIALIZE MIXPANEL
    this.mixpanelService.webviewInit(this.userEmail.toUpperCase());

    //* Consume Get Client System Assignation endpoint
    this.dealManagerService
      .getUserClientSystemAssignation({ user_id: this.userId }, this.userToken)
      .subscribe({
        next: (data) => {
          //* Map classrooms data. We filter classroom not assigned to the user, but also ones
          //* that only have them as a student.
          this.userClassrooms = (data?.class_list || [])
            .filter(
              ({ is_assigned, n_students }) => is_assigned && n_students > 1,
            )
            .map(({ id, name, campus_name }) => {
              return { id, name, campus_name };
            });

          //* Set dealId
          this.dealId = data?.deal?.id || '';

          //* Add the PROJECTS_INACAP to the Study Options if the User is in Deal INACAP
          if (data?.deal?.name.includes('INACAP'))
            this.studyOptions = INACAP_STUDY_OPTIONS;
          else this.studyOptions = SCHOOL_STUDY_OPTIONS;
          this.cdr.markForCheck();

          this.UserSessionService.infoUser(
            this.userId,
            this.userToken,
          ).subscribe({
            next: (data: any) => {
              this.isStudent = data?.response?.user?.user_type === 'STUDENT';
              //$ INITIALIZE THE APP
              this.displayView = true;
              this.updateState(ViewState.SELECTING_STUDY_OPTION);
              this.cdr.markForCheck();
            },
            error: (error) => this.handleInitialLoadError(error),
          });
        },
        error: (error) => this.handleInitialLoadError(error),
      });
  }

  private handleInitialLoadError(error: any): void {
    if (error?.status === 401) {
      this.authService.logout();
      return;
    }

    throw error;
  }

  //$ ---- SELECT STUDY OPTIONS AND SUB-OPTIONS ----
  /** Define the Study Option selected by the User. If it doesn't have a Sub-Option
   * then it goes directly into the chat, otherwise it progress to the Sub-Option selection UI.
   * It also send a Mixpanel event
   * @param studyOption Study Option selected by the user.
   */
  selectStudyOption(studyOption: StudyOption): void {
    //$ UPDATE COMPONENT CONTENT TYPE
    this.selectedStudyOption = studyOption;

    //$ MIXPANEL EVENT
    this.triggerContentTypeSelectedEvent(
      this.selectedStudyOption.keyword.toUpperCase(),
      this.selectedStudyOption.modifierId.toUpperCase(),
      this.selectedStudyOption.modifierTypeId.toUpperCase(),
    );

    //$ UPDATE SELECTABLE STUDY SUB-OPTIONS
    this.selectableStudySubOptions = this.studySubOptions.filter(
      ({ studyOptionKeyword, subjectModifierId }) =>
        studyOptionKeyword === studyOption.keyword &&
        subjectModifierId === this.selectedStudyOption.modifierId,
    );
    //$ UPDATE STATE
    if (this.selectableStudySubOptions.length > 0) {
      if (this.selectableStudySubOptions.length === 1)
        this.selectedStudySubOption = this.selectableStudySubOptions[0];
      this.updateState(ViewState.SELECTING_TFL);
    } else
      this.updateState(
        this.dealId && this.isStudent && this.userClassrooms.length > 0
          ? ViewState.SELECTING_TEAM
          : ViewState.CHATTING,
      );

    //$ UPDATE FRONT
    this.cdr.detectChanges();
  }

  /** Define the TFL selected by the User
   * @param tfl TFL selected by the User
   */
  selectTFL(tfl: StudySubOption) {
    //$ UPDATE COMPONENT TFL
    this.selectedStudySubOption = tfl;
  }

  /** Defines the TFL selected by the User and starts the chat. It also sends a Mixpanel event.
   */
  selectStudySubOption(): void {
    //$ MIXPANEL EVENT
    this.triggerContentSubtypeSelectedEvent(
      this.selectedStudyOption.keyword.toUpperCase(),
      this.selectedStudySubOption.keyword.toUpperCase(),
      this.selectedStudySubOption.modifierTypeId.toUpperCase(),
    );

    //$ UPDATE STATE
    this.updateState(
      this.dealId && this.isStudent && this.userClassrooms.length > 0
        ? ViewState.SELECTING_TEAM
        : ViewState.CHATTING,
    );

    //$ UPDATE FRONT
    this.cdr.detectChanges();
  }

  /** Toggle section collapsing
   * @param sectionId ID of the section
   */
  toggleSectionCollapsing(sectionId: string) {
    this.isSectionCollapsed[sectionId] = !this.isSectionCollapsed[sectionId];
  }

  /** Define the type of Teamwork selected by the User.
   * @param teamworkType Teamwork type selected by the User
   */
  selectTeamworkType(teamworkType: TeamworkType): void {
    //$ UPDATE COMPONENT CONTENT TYPE
    this.selectedTeamworkType = teamworkType;
    if (this.userClassrooms.length === 1)
      this.selectClassroom(this.userClassrooms[0]);
  }

  /** Define the classroom selected by the User for the teamwork.
   * @param classroom Classroom selected by the User
   */
  selectClassroom(classroom: {
    id: string;
    name: string;
    campus_name: string;
  }): void {
    //$ UPDATE COMPONENT CONTENT TYPE
    this.selectedClassroom = classroom;
    if (!Object.keys(this.fetchedClassroomStudents).includes(classroom.id)) {
      this.loadingClassroomProfile = true;
      this.clientSystemService
        .getClassroomInfo(
          classroom.id,
          this.dealId,
          this.userId,
          this.userToken,
        )
        .subscribe((data) => {
          this.fetchedClassroomStudents[classroom.id] = data.studentList
            .sort((studentA, studentB) => {
              const lastNameComparison = studentA.lastName.localeCompare(
                studentB.lastName,
              );
              if (lastNameComparison !== 0) return lastNameComparison;
              return studentA.firstName.localeCompare(studentB.firstName);
            })
            .map(({ id, firstName, lastName }) => {
              return {
                id,
                firstName: firstName.trim(),
                lastName: lastName.trim(),
              };
            });
          this.userClassmates = this.fetchedClassroomStudents[
            classroom.id
          ].filter((classmate) => classmate.id !== this.userId);
          this.loadingClassroomProfile = false;
          this.cdr.markForCheck();
        });
    } else
      this.userClassmates = this.fetchedClassroomStudents[classroom.id].filter(
        (classmate) => classmate.id !== this.userId,
      );
  }

  /** Toggle the selection of a classmate for the team.
   * @param classmate Classmate toggled by the User
   */
  toggleClassmateSelection(classmate: {
    id: string;
    firstName: string;
    lastName: string;
  }): void {
    if (!this.selectedClassmateIds.has(classmate.id)) {
      if (this.selectedClassmates.length < 4) {
        this.selectedClassmateIds.add(classmate.id);
        this.selectedClassmates = [...this.selectedClassmates, classmate];
      }
    } else {
      this.selectedClassmateIds.delete(classmate.id);
      this.selectedClassmates = this.selectedClassmates.filter(
        (selectedClassmate) => selectedClassmate.id !== classmate.id,
      );
    }
  }

  /** Determine if a classmate is part of the team.
   * @param classmate Classmate from the selected Classroom
   */
  isTeammate(classmate: {
    id: string;
    firstName: string;
    lastName: string;
  }): boolean {
    return this.selectedClassmateIds.has(classmate.id);
  }

  /** Get the formatted name for a teammate.
   * @param index Index of the teammate.
   */
  getTeammateName(index: number) {
    if (index === 0) return 'Yo';
    if (!this.selectedClassmates[index - 1].lastName)
      return this.selectedClassmates[index - 1].firstName;
    return `${this.selectedClassmates[index - 1].firstName} ${
      this.selectedClassmates[index - 1].lastName[0]
    }.`;
  }

  /**
   * Clear team selection for teamwork.
   */
  clearTeamworkSelection() {
    this.isSectionCollapsed = {
      TFL: false,
      'TEAMWORK-TYPE': false,
      CLASSROOM: false,
      CLASSMATES: true,
    };
    this.selectedTeamworkType = undefined;
    this.selectedClassroom = undefined;
    this.userClassmates = [];
    this.selectedClassmates = [];
    this.selectedClassmateIds = new Set<string>();
  }

  /** Select the definitive team for the chat */
  selectTeam() {
    // Update state to CHATTING and update UI
    this.updateState(ViewState.CHATTING);
    this.cdr.detectChanges();
  }

  //$ ---- CONVERSATIONS HISTORY ----
  /** Open the Chat History menu. It uses lazy loading to get the history from backend to not
   * waste too many resources
   */
  openHistoryChatMenu(disableOpenChatEvent = false): void {
    if (this.showHistoryChatMenu) {
      this.closeHistoryChatMenu();
      return;
    }

    this.showHistoryChatMenu = true;

    //$ UPDATE CHAT HISTORY CONTENT
    this.updateChatHistoryElements();
  }

  /** Call API to update the elements of the Chat List */
  updateChatHistoryElements() {
    //$ CONSUME API FOR CHAT HISTORY
    const query: GetAllChatSessionsForTutorIA_Req = {
      user_id: this.userId,
    };

    this.tutoriaService
      .getAllChatSessionsForTutorIA(query, this.userToken)
      .subscribe((data) => {
        this.chatHistoryElements = null;
        //* Define chat history elements in the local variable
        this.chatHistoryElements = data.map((rawChatSession) => {
          return {
            id: rawChatSession.chat_session_id,
            title: rawChatSession.title,
          };
        });
        this.cdr.markForCheck();
      });
  }

  /** Close the Chat History menu
   */
  closeHistoryChatMenu(): void {
    // The History Chat Menu can't be closed on desktop
    if (window.innerWidth >= this.desktopWidthBreakpoint) {
      this.updateChatHistoryElements();
      return;
    }

    this.showHistoryChatMenu = false;
    this.chatHistoryElements = null;
  }

  /** Toggle the Chat History sidebar */
  toggleChatHistorySidebar(): void {
    this.showHistoryChatSidebar = !this.showHistoryChatSidebar;
  }

  /** Start a new Chat Session from the Chat History menu */
  startNewChatSession(): void {
    this.resetChat();
  }

  /** Load an old Chat Session from the Chat History menu into the chatbot */
  loadChatSession(chatSessionId: string): void {
    // Arrange request query parameters
    const query: GetChatSessionForTutorIA_Req = {
      user_id: this.userId,
    };

    // Consume API
    this.tutoriaService
      .getChatSessionForTutorIA(query, chatSessionId, this.userToken)
      .subscribe((data) => {
        // Get the study options full object from the local array since the
        // API return only the id
        const thisStudyOption = this.studyOptions.find(
          (x) => x.keyword == data.content_type_id,
        ) ?? {
          name: '',
          labelVerb: '',
          keyword: '',
          modifierId: '',
          modifierTypeId: '',
          iconPath: '',
        };
        const thisStudySubOption = this.studySubOptions.find(
          (x) => x.keyword == data.content_subtype_id,
        ) ?? {
          name: '',
          keyword: '',
          modifierTypeId: '',
          studyOptionKeyword: '',
          subjectModifierId: '',
        };

        // Reset the view first to make sure all is clean
        this.resetChat();

        // Define the properties of the loaded Chat Session
        this.selectedStudyOption = thisStudyOption;
        this.selectedStudySubOption = thisStudySubOption;
        this.chatSessionId = chatSessionId;
        this.messagesToLoad = data.messages;

        // Update state to CHATTING and update UI
        this.updateState(ViewState.CHATTING);
        this.cdr.detectChanges();
      });
  }

  //$ ---- CHATBOT ----
  /** Sends the new chat message history to generate a new response.
   * @param chatMessageHistory array of ChatMessage instances to be sent to the endpoint.
   */
  sendChatMessageHistory(chatMessageHistory: ChatMessage[]) {
    if (!this.chatSessionId) return;
    const chatSessionId = this.chatSessionId;

    this.disableUserInput = true;

    const modifierIds = [];
    if (this.selectedStudyOption.modifierId)
      modifierIds.push(this.selectedStudyOption.modifierId);

    if (this.selectedStudySubOption.keyword)
      modifierIds.push(this.selectedStudySubOption.keyword);

    const bodyV3: CreateChatCompletionForTutorIAV3_Req = {
      chat_session_id: chatSessionId,
      messages: chatMessageHistory,
      content_type_id: this.selectedStudyOption.keyword,
      modifier_ids: modifierIds.length > 0 ? modifierIds : null,
      user_id: this.userId,
      teamwork_user_ids: Array.from(this.selectedClassmateIds),
    };

    this.tutoriaService
      .generateTutorIAResponseV3(bodyV3, this.userToken)
      .subscribe((data) => {
        this.assistantResponse = data.assistant_response;
        this.disableUserInput = false;
        this.cdr.markForCheck();
      });
  }

  /** Resets the view to its default values */
  resetChat() {
    this.selectedStudyOption = {
      name: '',
      labelVerb: '',
      keyword: '',
      modifierId: '',
      modifierTypeId: '',
      iconPath: '',
    };
    this.selectableStudySubOptions = [];
    this.selectedStudySubOption = {
      name: '',
      keyword: '',
      modifierTypeId: '',
      studyOptionKeyword: '',
      subjectModifierId: '',
    };
    this.isSectionCollapsed = {
      TFL: false,
      'TEAMWORK-TYPE': false,
      CLASSROOM: false,
      CLASSMATES: true,
    };
    this.chatSessionId = null;
    this.messagesToLoad = null;
    this.clearTeamworkSelection();
    this.closeHistoryChatMenu();

    this.updateState(ViewState.SELECTING_STUDY_OPTION);
    this.cdr.detectChanges();
  }

  /** Returns to home */
  returnToHome() {
    this.router.navigate([PrivateRoutes.HOME]);
  }

  //$ ---- STATE MACHINE ----
  /** Change the current state to a new one.
   * It applies logic depending on the old and new state if needed
   * @param newState New state to apply as the current state
   */
  updateState(newState: ViewState): void {
    if (newState === ViewState.CHATTING && !this.chatSessionId) {
      this.chatSessionId = guidV4().toUpperCase();
      this.triggerStartChatEvent(
        this.selectedStudyOption.keyword.toUpperCase(),
      );
    }

    if (newState === ViewState.CHATTING) this.closeHistoryChatMenu();

    this.currentState = newState;
  }

  /** Check if the current state of the page is the one requested
   * @param state The state to check for
   * @returns A boolean, if true the current state is the one requested
   */
  isState(state: ViewState): boolean {
    return state === this.currentState;
  }

  /**
   * Method to hide AI reminder.
   */
  hideAiReminder() {
    this.showAiReminder = false;
  }

  //$ ---- UTILITY ----
  /** Get the URL of the Sub-Option icon as a string from its Id/Keyword
   * @param subOptionId Id/Keyword of the Content Sub-Option to recover the Icon URL
   * @returns The URL of the Sub-Option icon requested
   */
  getStudySubOptionIcon(subOptionId: StudySubOption): string {
    return `../../assets/images/tutoria/sub-option-icons/${subOptionId}.svg`;
  }

  /** If the width is desktop or more and the history chat menu is hidden, then open it
   * since it should be there permanently in desktop. We explicitly disable the Mixpanel
   * event in this scenario.
   */
  updateChatHistoryMenuBasedOnWidth() {
    if (
      window.innerWidth >= this.desktopWidthBreakpoint &&
      !this.showHistoryChatMenu
    )
      this.openHistoryChatMenu(true);
    else this.closeHistoryChatMenu();
  }

  /** This is so we update the history chat menu visibility every time the screen is changed */
  @HostListener('window:resize', ['$event'])
  onResize(_event: any) {
    this.updateChatHistoryMenuBasedOnWidth();
  }

  /** Method to trigger the Open Chat event in different circumstances */
  triggerStartChatEvent(tutorIAContentTypeId: string) {
    this.mixpanelService.track(mixpanelEvent.TUTORIA_START_CHAT, {
      source_name: mixpanelEvent.SOURCE_NAME,
      feature_name: mixpanelEvent.TUTORIA_FEATURE_NAME,
      view_name: 'Miscelanea',
      event_version: 2,
      event_id: 329,
      event_type: 'Success',

      tool_id: mixpanelEvent.TUTORIA_TOOL_ID,
      tutoria_content_type_id: tutorIAContentTypeId,
    });
  }

  /** Method to trigger the Content Type Selected event in different circumstances */
  triggerContentTypeSelectedEvent(
    tutorIAContentTypeId: string,
    tutorIAModifierId = '',
    tutorIAModifierTypeId = '',
  ) {
    this.mixpanelService.track(mixpanelEvent.TUTORIA_CONTENT_TYPE_SELECTED, {
      source_name: mixpanelEvent.SOURCE_NAME,
      feature_name: mixpanelEvent.TUTORIA_FEATURE_NAME,
      view_name: 'Content List',
      event_version: 3,
      event_id: 264,
      event_type: 'Click',

      tool_id: mixpanelEvent.TUTORIA_TOOL_ID,
      tutoria_content_type_id: tutorIAContentTypeId,
      tutoria_modifier_id: tutorIAModifierId || null,
      tutoria_modifier_type_id: tutorIAModifierTypeId || null,
    });
  }

  /** Method to trigger the Content Subtype Selected event in different circumstances */
  triggerContentSubtypeSelectedEvent(
    tutorIAContentTypeId: string,
    tutorIAModifierId: string,
    tutorIAModifierTypeId: string,
  ) {
    this.mixpanelService.track(mixpanelEvent.TUTORIA_CONTENT_SUBTYPE_SELECTED, {
      source_name: mixpanelEvent.SOURCE_NAME,
      feature_name: mixpanelEvent.TUTORIA_FEATURE_NAME,
      view_name: 'Subcontent List',
      event_version: 3,
      event_id: 265,
      event_type: 'Click',

      tool_id: mixpanelEvent.TUTORIA_TOOL_ID,
      tutoria_content_type_id: tutorIAContentTypeId,
      tutoria_modifier_id: tutorIAModifierId,
      tutoria_modifier_type_id: tutorIAModifierTypeId,
    });
  }
}
